module.exports = __webpack_public_path__ + "static/media/reader_cd_2.39bae689.ico";